const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(":host{display:grid;grid-template-areas:\"layer\"}:host([hidden]){display:none}::slotted(vrf-stackedlayer){grid-area:layer}::slotted(vrf-stackedlayer:not([selected])){visibility:hidden}");
export default styleSheet;